namespace RioERP.Users {
    export interface CustomersRow {
        Id?: number;
        Name?: string;
        EmailId1?: string;
        EmailId2?: string;
        Mobile1?: string;
        Mobile2?: string;
        IsActive?: boolean;
        ECustomerType?: Web.Enums.CustomerType;
        AttemptId?: number;
        CourseId?: number;
        LevelId?: number;
        Gstin?: string;
        CouponCode?: string;
        HasPurchased?: boolean;
        CustomerDisplayName?: string;
        AttemptName?: string;
        CourseName?: string;
        LevelName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace CustomersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CustomerDisplayName';
        export const localTextPrefix = 'Users.Customers';
        export const lookupKey = 'Users.Customers';

        export function getLookup(): Q.Lookup<CustomersRow> {
            return Q.getLookup<CustomersRow>('Users.Customers');
        }
        export const deletePermission = 'Users:UsersManagement:Modify';
        export const insertPermission = 'Users:UsersManagement:Modify';
        export const readPermission = 'Users:UsersManagement:View';
        export const updatePermission = 'Users:UsersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            EmailId1 = "EmailId1",
            EmailId2 = "EmailId2",
            Mobile1 = "Mobile1",
            Mobile2 = "Mobile2",
            IsActive = "IsActive",
            ECustomerType = "ECustomerType",
            AttemptId = "AttemptId",
            CourseId = "CourseId",
            LevelId = "LevelId",
            Gstin = "Gstin",
            CouponCode = "CouponCode",
            HasPurchased = "HasPurchased",
            CustomerDisplayName = "CustomerDisplayName",
            AttemptName = "AttemptName",
            CourseName = "CourseName",
            LevelName = "LevelName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
